var map = {
	"./dekstop-screen-active.svg": "754c",
	"./dekstop-screen.svg": "27a1",
	"./drag-handle.svg": "2e9f",
	"./laptop-screen-active.svg": "217f",
	"./laptop-screen.svg": "c614",
	"./mobile-screen-active.svg": "682b",
	"./mobile-screen.svg": "81d8",
	"./page.svg": "0501",
	"./tablet-screen-active.svg": "7c6b",
	"./tablet-screen.svg": "7b3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f45";